module.exports = __webpack_public_path__ + "img/txm.44642912.svg";